import React from 'react';
import { SushiDulceLanding } from './pages/SushiDulceLanding';
export function App() {
  return <SushiDulceLanding data-id="element-0" />;
}